var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-center justify-center",staticStyle:{"height":"100vh"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"40"}}),_c('div',{staticClass:"mt-4"},[_vm._v("Verification completed. Importing the report...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }